import type { U2000TableColumn } from "../components/tables/basic/U2000BasicTableList";
import type { SortedFieldItem } from "../components/tables/commons/search/U2000BasicSearchSort";
import { u2000DefaultSortOrderForColumn } from "./U2000DefaultSortOrderForColumn";

/**
 * Calcule le prochain `sortedFields` après un clic sur un en-tête de colonne (BL-0405).
 * Tri mono-colonne : replace ou toggle ASC/DESC.
 * @returns `null` si aucun changement (colonne non triable).
 */
export function u2000ComputeHeaderSortFields(
  column: U2000TableColumn,
  currentSortedFields: SortedFieldItem[],
): SortedFieldItem[] | null {
  if (column.sortable !== true) {
    return null;
  }

  const current = currentSortedFields?.[0];
  const isCurrentColumn = current?.field?.name === column.name;

  // Sans ordre courant connu (filtre restauré sans sortOrder), on repart de l'ordre par défaut.
  if (isCurrentColumn && current.sortOrder) {
    return [{ field: { ...column }, sortOrder: current.sortOrder === "ASC" ? "DESC" : "ASC" }];
  }

  return [{ field: { ...column }, sortOrder: u2000DefaultSortOrderForColumn(column) }];
}
